import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { useLoading } from '../contexts/LoadingContext';

const GlobalLoader = () => {
  const { isLoading, loadingMessage } = useLoading();

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 flex items-center space-x-4 shadow-xl">
        <FontAwesomeIcon 
          icon={faSpinner} 
          className="animate-spin text-blue-600 text-xl" 
        />
        <span className="text-gray-700 font-medium">{loadingMessage}</span>
      </div>
    </div>
  );
};

export default GlobalLoader;
